<div class="header">
  <h3>{{ title }}</h3>
   <i
       (click)="action(false)"
       (keydown.enter)="action(false)"
       tabindex="0"
       role="button"
       class="close-icon icon-cross_16px"></i>
</div>
<div class="info-modal-content">
  <p>{{ description }}</p> <!-- Render the description -->
</div>
<div class="info-modal-controls">
  <button id="confirm"
          type="button"
          class="button primary"
          (click)="action(true)">{{ buttonsTitle.confirm }}</button>
</div>